import { type Experiences } from '@data/types/Experiences'
import { track } from './datalayer'
import { trackEventStream } from './eventStream'

export const trackExperiments = (experiences: Experiences): void => {
  Object.entries(experiences).forEach(([experiment, { cohort, iteration }]) => {
    track('Experience Bucket', `${experiment}:${cohort}`, null, true)

    if (!/^experiment/.test(experiment)) {
      return // if not experiment do nothing
    }

    const eventStreamObject = { experiment_id: experiment, iteration_id: iteration, variation_id: `${cohort}` }

    trackEventStream('Experiment Loaded', eventStreamObject)

    if (experiment === 'experiment-partytown' && cohort !== 1) {
      // in control do nothing as experiment is tracked using track()
    }
  })
}
